import request from "@/axios.js";

export default class Dns {
	/**
	 * Dns class
	 * @property {string} id - Dns id.
	 * @property {string} lang - language.
	 * @property {string} login - dns login.
	 * @property {string} pass - dns password.
	 * @property {string} domain_activity - domain of activity.
	 * @property {number} host - hostname.
	 * @property {number} port - connecting port.
	 * @property {number} price - price.
	 * @property {number} provider_id - id of provider where the dns has been bought.
	 * @property {number} purchase_id - id of purchase.
	 * @property {number} purchase_date - date of purchase.
	 * @property {number} renew_date - date of renewal.
	 * @property {number} before_renew_duration - duration before renew notification calculated from renew_date.
	 * @property {number} domain_authority - an domain_authority.
	 * @property {number} referring_domains - a referring_domains.
	 * @property {number} referring_links - a referring_links.
	 * @property {number} society_counter - how many society on the dns.
	 * @property {number} total_links - an total_links.
	 * @property {number} status - dns status.
	 */
	constructor(dns) {
		this.id = dns.id || null;
		this.lang = dns.lang || null;
		this.login = dns.login || null;
		this.pass = dns.pass || null;
		this.domain_activity = dns.domain_activity || null;
		this.host = dns.host || null;
		this.port = dns.port || null;
		this.price = dns.price || 0;
		this.provider_id = dns.provider_id || null;
		this.purchase_id = dns.purchase_id || null;
		this.purchase_date = dns.purchase_date || null;
		this.renew_date = dns.renew_date || null;
		this.before_renew_duration = dns.before_renew_duration || null;
		this.domain_authority = dns.domain_authority || null;
		this.referring_domains = dns.referring_domains || null;
		this.referring_links = dns.referring_links || null;
		this.society_counter = dns.society_counter || 0;
		this.total_links = dns.total_links || null;
		this.status = dns.status || 1;
	}

	static getFormFields() {
		/*
		 * let today = new Date(Date.now())
		 * let todayString = today.toISOString()
		 * todayString = todayString.substring(0,10)
		 * todayString = todayString + " 02:00:00"
		 */

		return {
			id: null,
			lang: null,
			login: null,
			pass: null,
			domain_activity: null,
			host: null,
			port: null,
			price: 0,
			provider_id: null,
			purchase_id: null,
			purchase_date: null,
			renew_date: null,
			before_renew_duration: null,
			domain_authority: null,
			referring_domains: null,
			referring_links: null,
			society_counter: null,
			total_links: null,
			status: 1,
		};
	}

	create(callback){
		if(this.purchase_date && this.renew_date){
			request.post("/dns/add", this)
				.then(res => {
					callback(null, res);
				})
				.catch(err => {
					callback(err, null);
				});
		}
		else{
			callback("Date not set.", null);
		}
	}

	update(callback){
		if(this.purchase_date && this.renew_date){
			request.post("/dns/edit", this)
				.then(res => {
					callback(null, res);
				})
				.catch(err => {
					callback(err, null);
				});
		}
		else{
			callback("Date not set.", null);
		}
	}

	static updateAllForPurchase(purchase_id, dnss, callback){
		if(purchase_id && dnss){
			request.post("/dns/update", {
				purchase_id: purchase_id,
				dns: JSON.stringify(dnss)
			})
				.then(res => {
					callback(null, res);
				})
				.catch(err => {
					callback(err, null);
				});
		}
		else{
			callback("Arguments not set.", null);
		}
	}

	/*
	 * static getNetlinksForPurchase(purchaseId, callback){
	 *   request.get("/dns/getp/" + purchaseId)
	 *     .then(res => {
	 *       callback(null, res)
	 *     })
	 *     .catch(err => {
	 *       callback(err, null)
	 *     })
	 * }
	 */

	/*
	 * static getNetlinksForRecurringPurchase(recurringPurchaseId, callback){
	 *   request.get("/dns/getrp/" + recurringPurchaseId)
	 *     .then(res => {
	 *       callback(null, res)
	 *     })
	 *     .catch(err => {
	 *       callback(err, null)
	 *     })
	 * }
	 */

	static delete(dnsId, callback){
		request.delete("/dns/delete/" + dnsId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}
}
